<template>
  <div>
    <p class="text-muted">The next few questions help us do this.</p>
    <b-button block variant="primary" @click="next()">Next</b-button>
  </div>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
    },
  },
  methods: {
    next() {
      this.$emit('answered', { value: null });
    },
  },
  mounted() {
  },
};
</script>
